<template>
  <v-row no-gutters class="my-2" :style="{ marginLeft: isExpandedTableRow ? '3%' : undefined }">
    <v-col cols="12">
      <v-tabs class="card-tabs sub-tabs" v-model="financialCategoryTab">
        <v-tab v-show="hasPayables">
          <v-icon class="mr-1">{{ IconHelpers.getIconForObjectType('accountsPayable') }}</v-icon>
          <span>{{ $t('payables') }}</span>
        </v-tab>

        <v-tab v-show="hasReceivables">
          <v-icon class="mr-1">{{ IconHelpers.getIconForObjectType('accountsReceivable') }}</v-icon>
          <span>{{ $t('receivables') }}</span>
        </v-tab>

        <v-tab v-show="hasAccruals">
          <v-icon class="mr-1">{{ IconHelpers.getIconForObjectType('journalEntry') }}</v-icon>
          <span>{{ $t('accruals') }}</span>
        </v-tab>
      </v-tabs>
    </v-col>

    <v-col cols="12">
      <v-card outlined style="max-width: 600px; border-radius: 0px 4px 4px 4px;">
        <v-data-table
        dense
        class="small-headers"
        :headers="amountHeaders"
        hide-default-footer
        :items-per-page="-1"
        :items="filteredAmounts">
          <template #item.amount="{ item }">
            <span>{{ formatMoney(item.amount) }}</span>
          </template>
            <template #item.rate="{ item }">
              <v-row
              no-gutters
              justify="end"
              align="center">
                <v-col
                cols="auto"
                v-if="item?.rateSheetLineId > 0">
                  <Icon
                    icon="mdi-note-text"
                    iconColor="primary"
                    :tooltipText="item.rateSheetName"
                    @icon-clicked="rateSheetDetailClicked(item)"
                    :small="false"
                  />
                </v-col>
                <v-col cols="auto">
                  <span>{{ formatMoney(item.rateSheetLineId > 0 ? item.computedAtRate : item.financial?.computedAtRate) }}</span>
                </v-col>
              </v-row>
            </template>
        </v-data-table>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import { formatMoney } from '@/utils/NumericMutations'
import IconHelpers from '@/utils/IconHelpers'
import { AccountingCategory } from '@/utils/Enumerations'
import { uniqBy } from 'lodash'

export default {
  name: 'TicketScaleDataFinancials',

  components: {
    Icon: () => import('@/components/helper/Icon.vue')
  },

  props: {
    segmentOrLog: {
      type: Object,
      required: true
    },
    isExpandedTableRow: {
      type: Boolean,
      default: false
    }
  },

  data: () => ({
    IconHelpers,
    financialCategoryTab: null
  }),

  created () {
    if (this.hasPayables) {
      this.financialCategoryTab = AccountingCategory.Payable.value
    } else if (this.hasReceivables) {
      this.financialCategoryTab = AccountingCategory.Receivable.value
    } else if (this.hasAccruals) {
      this.financialCategoryTab = AccountingCategory.Accrual.value
    }
  },

  computed: {
    amountHeaders () {
      return [
        this.includeBusinessEntity ? { text: this.$t('entity'), value: 'financial.businessEntityName' } : undefined,
        { text: this.$t('activity'), value: 'activity' },
        { text: this.$t('rate'), value: 'rate', align: 'right' },
        { text: this.$t('amount'), value: 'amount', align: 'right' }
      ].filter(i => i)
    },

    includeBusinessEntity () {
      const businessEntityIds = this.filteredAmounts.map(a => a.financial.businessEntityId)
      return uniqBy(businessEntityIds).length > 1
    },

    filteredAmounts () {
      let segment
      if (this.segmentOrLog.type === 'segment') {
        segment = this.segmentOrLog
      } else {
        segment = this.segmentOrLog.segments.find(s => s.amounts.length > 0)
      }

      if (!segment.amounts || segment.amounts.length === 0) return []
      return segment.amounts.filter(amount => amount.type === this.financialCategoryTab)
    },

    segmentWithFinancials () {
      return this.segmentOrLog.type === 'segment' ? this.segmentOrLog : this.segmentOrLog.segments.find(s => s.amounts.length > 0)
    },

    hasPayables () {
      return this.segmentWithFinancials?.amounts?.some(amount => amount.type === AccountingCategory.Payable.value)
    },

    hasReceivables () {
      return this.segmentWithFinancials?.amounts?.some(amount => amount.type === AccountingCategory.Receivable.value)
    },

    hasAccruals () {
      return this.segmentWithFinancials?.amounts?.some(amount => amount.type === AccountingCategory.Accrual.value)
    }
  },

  methods: {
    formatMoney,

    rateSheetDetailClicked (item) {
      this.$emit('rate-sheet-detail-clicked', item)
    }
  }
}
</script>
